import { InjectionToken } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
/**
 * @abstract
 */
export abstract class RouterStateSerializer<T> {
/**
 * @abstract
 * @param {?} routerState
 * @return {?}
 */
serialize(routerState: RouterStateSnapshot) {}
}
export class DefaultRouterStateSerializer
  implements RouterStateSerializer<RouterStateSnapshot> {
/**
 * @param {?} routerState
 * @return {?}
 */
serialize(routerState: RouterStateSnapshot) {
    return routerState;
  }
}



// WEBPACK FOOTER //
// ../../../modules/router-store/src/serializer.ts